import React, { Suspense, useCallback, useMemo, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import "./App.css";
import Navigation from "./Navigation";
import NotificationListener from "./NotificationListener";
import { SnackbarProvider } from "./components/CommonComponents/SnackbarProvider";
import Header from "./components/Header";
import Sidebar from "./components/SideBar/Sidebar";
import { ThemeProvider } from "./context/themeContext";
import PrivateRoute from "./route/privateRoute";
import { showConsole } from "./config/config";

// Memoized Header and Sidebar (only re-render when props change)
const MemoizedHeader = React.memo(Header);
const MemoizedSidebar = React.memo(Sidebar);
const MemoizedNotificationListener = React.memo(NotificationListener);

// Wrapper to handle layout (hide Header/Sidebar on login & alerts)
const LayoutWrapper = React.memo(({ children }) => {
  const [events, setEvents] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  // Hide layout on login/alerts
  const hideLayout = useMemo(
    () => ["/", "/alerts"].includes(location.pathname),
    [location.pathname],
  );

  const handleSetEvents = useCallback((newEvents) => {
    setEvents(newEvents);
  }, []);

  return (
    <>
      {!hideLayout && (
        <>
          <MemoizedHeader events={events} setEvents={setEvents} />
          <MemoizedSidebar
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
          />
          <PrivateRoute>
            <MemoizedNotificationListener setEvents={handleSetEvents} />
          </PrivateRoute>
        </>
      )}

      {/* Main content wrapper that resizes */}
      <div
        style={{
          marginLeft: hideLayout ? 0 : isExpanded ? "17rem" : "4rem",
          width: hideLayout ? "100%" : isExpanded ? "84%" : "96%",
          marginTop: hideLayout ? 0 : "5rem",
          transition: "all 0.3s ease-in-out",
        }}
      >
        {children}
      </div>
    </>
  );
});

const FallbackLoader = () => (
  <div style={{ width: "50%", margin: "auto" }}>Loading...</div>
);

const App = React.memo(() => {
  //   useEffect(() => {
  //     // Check if the user navigated to the page directly (e.g., by copy-pasting the URL)
  //     const navEntries = window.performance.getEntriesByType("navigation");
  //     const isDirectNavigate =
  //       navEntries.length > 0 && navEntries[0].type === "navigate";

  //     // If it's a direct navigation to a route other than the login page, log them out
  //     // We allow navigation if window.opener exists, to support window.open() from the dashboard
  //     alert(
  //       `isDirectNavigate: ${isDirectNavigate}
  // window.opener: ${window.opener ? "exists" : "null"}
  // pathname: ${window.location.pathname}
  // navEntries: ${JSON.stringify(navEntries, null, 2)}`,
  //     );

  //     console.log("yashnavigate", isDirectNavigate, navEntries, window.opener);
  //     if (
  //       isDirectNavigate &&
  //       !window.opener &&
  //       window.location.pathname !== "/" &&
  //       window.location.pathname !== ""
  //     ) {
  //       sessionStorage.clear();
  //       window.location.href = "/";
  //     }
  //   }, []);

  if (showConsole) {
    console.log = () => {};
    console.error = () => {};
    console.debug = () => {};
    console.warn = () => {};
  }
  return (
    <main className="App">
      <BrowserRouter>
        <ThemeProvider>
          <SnackbarProvider>
            <LayoutWrapper>
              <Suspense fallback={<FallbackLoader />}>
                <Navigation />
              </Suspense>
            </LayoutWrapper>
          </SnackbarProvider>
        </ThemeProvider>
      </BrowserRouter>
    </main>
  );
});

export default App;
